
<template>
      <h5>
            已有
            <span v-for="(item,index) in parnum" :key="index">{{item}}</span>
            人参与活动
        </h5>
</template>

<script>
export default {
  props:['cardActivityNo'],
  data () {
      return {
        parnum:'',
      }
    },
    created(){
      var m=this;
      //  查询参加人数
      this.HTTP.countUsernum(m.cardActivityNo).then((res) => {
             var num=res.body.content.count;
              num += '';
              m.parnum=num.split('');
        }, (err) => {
            console.log(err);
        });
    },
}
</script>

<style scoped>
    .card-box h5{
    width: 100%;
    text-align: center;
    font-size: .32rem;
    color: #FFD388;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/t1.png) no-repeat center;
    background-size: 6.9rem .76rem;
    height: .76rem;
    line-height: .76rem;
}
.card-box h5 span{
    display: inline-block;
    width: .34rem;
    height: .48rem;
    text-align: center;
    line-height: .48rem;
    border-radius: .1rem;
    background-color: #FFBC1D1E;
    color: #FFD388;
    font-size: .36rem;
    margin-right: .02rem;
}
</style>



// WEBPACK FOOTER //
// src/components/commont/participate.vue